import {
  Outlet,
  redirect,
  createRootRoute,
  createRoute,
  createRouter
} from "@tanstack/react-router";
import { HomePage } from "./routes/HomePage";
import { PostPage } from "./routes/PostPage";
import { AdminPage } from "./routes/AdminPage";
import { BlogPage } from "./routes/BlogPage";
import { ProjectsPage } from "./routes/ProjectsPage";
import { ProjectDetailPage } from "./routes/ProjectDetailPage";
import { CurriculumPage } from "./routes/CurriculumPage";
import { ContactsPage } from "./routes/ContactsPage";
import { ProfilePage } from "./routes/ProfilePage";
import { AuthDialogProvider } from "./components/AuthDialog";

import { CoursesPage } from "./routes/CoursesPage";

const rootRoute = createRootRoute({
  component: () => <AuthDialogProvider><Outlet /></AuthDialogProvider>
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: HomePage
});

const postRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/post/$slug",
  component: PostPage
});

const blogRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/blog",
  component: BlogPage
});

const projectsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/projects",
  component: ProjectsPage
});

const projectDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/projects/$slug",
  component: ProjectDetailPage
});

const curriculumRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/resume",
  component: CurriculumPage
});

const contactsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/contact",
  component: ContactsPage
});

const adminRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/admin",
  component: AdminPage
});

const profileRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/profile",
  component: ProfilePage
});

const coursesRoute = createRoute({ getParentRoute: () => rootRoute, path: "/courses", component: CoursesPage });

const legacyProjects = createRoute({ getParentRoute: () => rootRoute, path: '/projetos', beforeLoad: () => { throw redirect({ to: '/projects', replace: true }); } });
const legacyProject = createRoute({ getParentRoute: () => rootRoute, path: '/projetos/$slug', beforeLoad: ({ params }) => { throw redirect({ to: '/projects/$slug', params: { slug: params.slug }, replace: true }); } });
const legacyResume = createRoute({ getParentRoute: () => rootRoute, path: '/curriculo', beforeLoad: () => { throw redirect({ to: '/resume', replace: true }); } });
const legacyContact = createRoute({ getParentRoute: () => rootRoute, path: '/contactos', beforeLoad: () => { throw redirect({ to: '/contact', replace: true }); } });
const legacyProfile = createRoute({ getParentRoute: () => rootRoute, path: '/perfil', beforeLoad: () => { throw redirect({ to: '/profile', replace: true }); } });
const routeTree = rootRoute.addChildren([indexRoute, blogRoute, projectsRoute, projectDetailRoute, curriculumRoute, contactsRoute, postRoute, adminRoute, profileRoute, coursesRoute, legacyProjects, legacyProject, legacyResume, legacyContact, legacyProfile]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
